export default __webpack_public_path__ + "static/media/main-bg-item3.c60161a7.png";